// extracted by mini-css-extract-plugin
export default {"row":"_6cc7d7a44404bd43","rowLabel":"_4052c63ef20d890a","rowValue":"_86bc268a3130b8ec"};